import { Link } from "react-router-dom";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-950 text-foreground-300">
      <div className="w-full px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block mb-4">
              <span className="text-xl font-heading text-background-50 whitespace-nowrap">
                羞羞色漫
              </span>
            </Link>
            <p className="text-sm leading-relaxed text-foreground-400">
              精选漫画资源汇聚平台，为成年读者提供高清流畅的漫画阅读体验。涵盖恋爱、奇幻、都市、悬疑等多种题材。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速链接</h4>
            <nav className="flex flex-col gap-2" aria-label="页脚导航">
              <Link to="/" className="text-sm text-foreground-400 hover:text-accent-500 transition-colors duration-200 whitespace-nowrap">
                首页
              </Link>
              <Link to="/category/all" className="text-sm text-foreground-400 hover:text-accent-500 transition-colors duration-200 whitespace-nowrap">
                全部分类
              </Link>
              <Link to="/about" className="text-sm text-foreground-400 hover:text-accent-500 transition-colors duration-200 whitespace-nowrap">
                关于我们
              </Link>
            </nav>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">热门分类</h4>
            <nav className="flex flex-col gap-2" aria-label="分类导航">
              <Link to="/category/romance" className="text-sm text-foreground-400 hover:text-accent-500 transition-colors duration-200 whitespace-nowrap">
                恋爱言情
              </Link>
              <Link to="/category/fantasy" className="text-sm text-foreground-400 hover:text-accent-500 transition-colors duration-200 whitespace-nowrap">
                奇幻冒险
              </Link>
              <Link to="/category/urban" className="text-sm text-foreground-400 hover:text-accent-500 transition-colors duration-200 whitespace-nowrap">
                都市生活
              </Link>
              <Link to="/category/suspense" className="text-sm text-foreground-400 hover:text-accent-500 transition-colors duration-200 whitespace-nowrap">
                悬疑推理
              </Link>
            </nav>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">免责声明</h4>
            <p className="text-sm leading-relaxed text-foreground-400">
              本站内容仅供18岁以上成年读者浏览。所有漫画资源均来源于网络，如有版权问题请联系我们处理。
            </p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-foreground-800/50 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-sm text-foreground-500">
            &copy; {currentYear} 羞羞色漫. 保留所有权利.
          </p>
          <p className="text-sm text-foreground-500">
            18岁以下未成年人请勿浏览
          </p>
        </div>
      </div>
    </footer>
  );
}